/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Log_HintInputs */

const cs_gdpr_log_hint = /** @type {(inputs: Gdpr_Log_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny klientů, poptávek a uživatelů a všechny exporty / anonymizace. Hodnoty jsou skryté, vidíte jen názvy polí.`)
};

const en_gdpr_log_hint = /** @type {(inputs: Gdpr_Log_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes to clients, leads and users plus every export / anonymisation. Values are hidden; you see field names only.`)
};

/**
* | output |
* | --- |
* | "Changes to clients, leads and users plus every export / anonymisation. Values are hidden; you see field names only." |
*
* @param {Gdpr_Log_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_log_hint = /** @type {((inputs?: Gdpr_Log_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Log_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_log_hint(inputs)
	return cs_gdpr_log_hint(inputs)
});